// @flow

import type { InteractivesMenuItemConfig } from "../interactives-list";
import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import DisplayImage from "./image.png";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";

const description =
  "A widget for embedding short videos onto the page, playing each in an infinite loop.";

const CONFIG: InteractivesMenuItemConfig = {
  author: undefined,
  name: "Video loop",
  id: "video-loop",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Video", "Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/autoplay-video-loop/live/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "VideoLoopConfigTool" */ "app/components/tools/VideoLoopConfigTool/VideoLoopConfigTool"),
    loading: DynamicImportLoader,
    modules: ["VideoLoopConfigTool"]
  })
};

export default CONFIG;
